import React, { FC, ReactNode } from "react"
import {
  Col,
  Grid,
  ReactStyledFlexboxgrid,
  Row,
} from "react-styled-flexboxgrid"
import { gridColumnProps } from "../../util/styles/grid-column-props"

export interface TwoColLayoutProps {
  children: {
    firstCol: ReactNode
    secondCol: ReactNode
  }
  firstColProps?: ReactStyledFlexboxgrid.IColProps
  secondColProps?: ReactStyledFlexboxgrid.IColProps
}

export const TwoColLayout: FC<TwoColLayoutProps> = ({
  children: { firstCol, secondCol },
  firstColProps,
  secondColProps,
}) => (
  <Grid>
    <Row>
      <Col {...gridColumnProps.twoColumns} {...firstColProps}>
        {firstCol}
      </Col>
      <Col {...gridColumnProps.twoColumns} {...secondColProps}>
        {secondCol}
      </Col>
    </Row>
  </Grid>
)
